import React, { } from "react";
import { faFileImage } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box } from "@mui/material";
import { exportComponentAsPNG } from 'react-component-export-image';

import { exportColor, iconSize } from "../App/GridRenderers";
import { GoogleAnalyticsEvent } from "./ga4";

export const ChartExport = ({ chartRefFn = null, filename = "export", titleFn }) => {


    const onChartDownload = () => {
        let chartRef = chartRefFn()
        let titleO = titleFn()
        let title = titleO.text

        if (chartRef !== null && chartRef.current !== null) {
            chartRef.current.download({
                fileName: filename + " " + title + ".png",
                fileFormat: "image/png",
                width: 1700,
                height: 800,
            })
            GoogleAnalyticsEvent("png", "chart", "scenario", { action: "download", type: "chart" })
        }
    }

    return (
        (chartRefFn !== null && chartRefFn() !== null &&
            <Box sx={{ pt: 1 }}>
                <FontAwesomeIcon
                    icon={faFileImage}
                    onClick={onChartDownload}
                    size={iconSize}
                    color={exportColor}
                />
            </Box>
        )
    )
}

export const ChartExportSankey = ({ chartRefFn = null, filename = "export", titleFn }) => {


    const onChartDownload = () => {
        let chartRef = chartRefFn()
        let titleO = titleFn()
        let title = titleO.text

        console.log(title)
        console.log(filename)
        console.log(chartRef)
        console.log(chartRef.current)

        // right now the sankey chart does not support forwardRef()
        // so the ref is always null

        if (chartRef !== null && chartRef.current !== null) {
            exportComponentAsPNG(chartRef.current, {
                fileName: filename + " " + title + ".png",

            })
            GoogleAnalyticsEvent("png", "chart", "sankey", { action: "download", type: "sankey" })
        }
    }

    return (
        (chartRefFn !== null && chartRefFn() !== null &&
            <Box sx={{ pt: 1 }}>
                <FontAwesomeIcon
                    icon={faFileImage}
                    onClick={onChartDownload}
                    size={iconSize}
                    color={exportColor}
                />
            </Box>
        )
    )
}
